import { masterAxios } from "../../core/MasterAPIInterceptor";

export async function getLanguageLabels(languageCD, userInterfaceCD) {
    const response = await masterAxios.get(`langLabel/${userInterfaceCD}/${languageCD}`);
    return response.data;
}
